module.exports = __webpack_public_path__ + "img/6_transparent.32191b73.png";